import './v2-base.js';
import '../../static/racing/js/v2/results.js';
import { initCourseChips } from '../../static/racing/js/v2/course_chips.js';

initCourseChips();
import { initResultsSearch } from '../../static/racing/js/v2/results_search.js';

initResultsSearch();
